import { Phone, MessageCircle } from 'lucide-react';

const PHONE_NUMBER = "+919971231812";
const WHATSAPP_NUMBER = "919971231812";
const WHATSAPP_MESSAGE = encodeURIComponent("Hi! I'm interested in your products. Please share more details.");

export const FloatingButtons = () => {
  return (
    <>
      {/* WhatsApp Button - Bottom Right */}
      <a
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20BA5C] text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-transform whatsapp-pulse"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="w-6 h-6" fill="currentColor" />
      </a>

      {/* Call Button - Bottom Left (Mobile Only) */}
      <a
        href={`tel:${PHONE_NUMBER}`}
        data-testid="floating-call-btn"
        className="fixed bottom-6 left-6 z-50 bg-teal-600 hover:bg-teal-700 text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-transform call-pulse md:hidden"
        aria-label="Call Now"
      >
        <Phone className="w-6 h-6" />
      </a>
    </>
  );
};

export default FloatingButtons;
